module.exports = __webpack_public_path__ + "img/icon-2.bfa4f9e2.svg";